import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import WorkOrders from "@/pages/WorkOrders";
import WorkOrderDetail from "@/pages/WorkOrderDetail";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Catalog from "@/pages/Catalog";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Users from "@/pages/Users";

function OwnerOnly({ children }) {
  const { isOwner } = useAuth();
  return isOwner ? children : <Navigate to="/" replace />;
}

function AppRoutes() {
  const { status } = useAuth();
  if (status === "checking") return <div className="min-h-screen flex items-center justify-center text-white/50">Loading…</div>;
  if (status === "setup") return <Setup />;
  if (status === "guest") return <Login />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/customers/:id" element={<CustomerDetail />} />
        <Route path="/work-orders" element={<WorkOrders />} />
        <Route path="/work-orders/:id" element={<WorkOrderDetail />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/:id" element={<InvoiceDetail />} />
        <Route path="/catalog" element={<Catalog />} />
        {/* Legacy redirects */}
        <Route path="/products" element={<Navigate to="/catalog" replace />} />
        <Route path="/materials" element={<Navigate to="/catalog" replace />} />
        <Route path="/users" element={<OwnerOnly><Users /></OwnerOnly>} />
        <Route path="/settings" element={<OwnerOnly><Settings /></OwnerOnly>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
